module.exports = __webpack_public_path__ + "img/platform-logo-default1.225ca571.png";